import React, { useState, useEffect, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import './Sidebar.css';
import MenuIcon from '@mui/icons-material/Menu';
import AppsIcon from '@mui/icons-material/Apps';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import PersonIcon from '@mui/icons-material/Person';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { handleButtonClickEventBuilder, sendEvent } from '../../utils/event-helpers';
import { useAppSelector } from '../../app/store';


const Sidebar = ({ children }) => {
  const [isOpen, setIsOpen] = useState(true);
  const { userId, sessionId } = useAppSelector((state) => state.session);
  const sidebarRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (window.innerWidth <= 768 && 
          sidebarRef.current && 
          !sidebarRef.current.contains(event.target) &&
          !event.target.closest('.sidebar-toggle')) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const toggle = () => setIsOpen(!isOpen);

  const menuItem = [
    { path: "/recommenderpage", name: "Home", icon: <AppsIcon /> },
    {
      path: "/recommenderpage/bookmarks",
      name: "Bookmarks",
      icon: <BookmarkIcon />,
    },
    { path: "/recommenderpage/mentors", name: "Mentors", icon: <PersonIcon /> },
    { path: "/recommenderpage/settings", name: "Settings", icon: <MiscellaneousServicesIcon /> },
    { path: "/recommenderpage/logout", name: "Logout", icon: <ExitToAppIcon /> },
  ];

  return (
    <div className="container">
      <div className={`sidebar ${!isOpen ? 'closed' : ''}`}>
        <div className="top-section">
          {isOpen && (
            <div className="logo">
              <img
                src="/images/Pathways.png"
                alt="Pathways Logo"
                className="pathways-logo"
              />
            </div>
          )}
          <div className="bars" style={{ marginLeft: isOpen ? "45px" : "-4px" }}>
            <MenuIcon
              className="fa-bars-icon"
              onClick={toggle}
              style={{ fontSize: "24px" }}
            />
          </div>
        </div>

        <nav className="menu-items">
          {menuItem.map((item, index) => (
            <NavLink
              onClick={() => {
                const eventData = handleButtonClickEventBuilder(userId, sessionId, item.name, {});
                sendEvent(eventData);
              }}
              to={item.path}
              key={index}
              className={({ isActive }) => 
                `menu-item ${isActive ? 'active' : ''}`
              }
            >
              <div className="icon-wrapper">
                {item.icon}
                {isOpen && (
                  <span className="item-text">{item.name}</span>
                )}
              </div>
              {!isOpen && (
                <div className="tooltip">{item.name}</div>
              )}
            </NavLink>
          ))}
        </nav>
      </div>
      <main className="main-content">
        {React.Children.map(children, child =>
          React.cloneElement(child, { isSidebarOpen: isOpen })
        )}
      </main>
    </div>
  );
};

export default Sidebar;